export class ServerConfigurationModel {
  constructor(
    public name: string,
    public configProperties: any
  ) { }
}
